import { isCreditRecoveryEnabledForEvent } from './credit-booking-fee';
import type { Event } from '@/types';

/** Default booking fee (pence) when the event has no stored fee (per billable RSVP slot). */
export const DEFAULT_CREDIT_BOOKING_FEE_PENCE = 60;

/** Maximum booking fee per paying RSVP slot (pence), i.e. £5.00. */
export const MAX_CREDIT_BOOKING_FEE_PENCE = 500;

/**
 * Normalise per-slot booking fee in whole pence (non-negative, capped at {@link MAX_CREDIT_BOOKING_FEE_PENCE}).
 */
export function normalizeCreditBookingFeePence(raw: unknown): number {
  if (typeof raw !== 'number' || !Number.isFinite(raw) || raw < 0) {
    return DEFAULT_CREDIT_BOOKING_FEE_PENCE;
  }
  return Math.min(MAX_CREDIT_BOOKING_FEE_PENCE, Math.round(raw));
}

/** Per-event booking fee (pence) used when credit cost recovery applies to the guest invoice. */
export function getCreditBookingFeePenceForEvent(event: Event | null | undefined): number {
  if (!isCreditRecoveryEnabledForEvent(event)) {
    return 0;
  }
  if (typeof event?.creditBookingFeePence !== 'number' || !Number.isFinite(event.creditBookingFeePence)) {
    return DEFAULT_CREDIT_BOOKING_FEE_PENCE;
  }
  return normalizeCreditBookingFeePence(event.creditBookingFeePence);
}
